import { render, staticRenderFns } from "./order-info.pug?vue&type=template&id=cacc7d54&lang=pug&"
import script from "./order-info.ts?vue&type=script&lang=ts&"
export * from "./order-info.ts?vue&type=script&lang=ts&"
import style0 from "./order-info.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports